import React from 'react';
import { Link } from 'gatsby';
import FooterLogos from "../assets/img/footer-logos.png";

const Footer = () => {
    return (
      <footer id="footer">
        <div className="container d-flex justify-content-between pt-4">
          <div>
            &copy; Copyright <strong><span>Level1Analytics LLC</span></strong> {new Date().getFullYear()}. All Rights Reserved
            <br/><Link to="/terms-of-use">Terms of Use</Link> | <Link to="/privacy-policy">Privacy Policy</Link>
          </div>
          <div>
            <img src={FooterLogos} className="img-fluid" width="310" height="58" />
          </div>
        </div>
      </footer>
    );
}

export default Footer;
